module.exports = __webpack_public_path__ + "images/emoji/couple.4c1624ce6c120349785b.png";